import { DocumentReferenceViewModel } from "../../model/DocumentReferenceViewModel";
import { api, transformApiResponse } from "./BaseApi";

const getExamResultUrl = (id?: string) => "/ExamResult" + (id === undefined ? "" : `/${id}`);

const examResultsApi = api.enhanceEndpoints({ addTagTypes: ["ExamResults"] }).injectEndpoints({
  endpoints: (builder) => ({
    getExamResults: builder.query<DocumentReferenceViewModel[], void>({
      query: () => getExamResultUrl(),
      transformResponse: transformApiResponse,
      providesTags: [{ type: "ExamResults", id: "LIST" }],
    }),
  }),
});

export const { endpoints, useGetExamResultsQuery } = examResultsApi;
